export default function Tick() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Tick icon</title>
      <path
        d="M17.9961 9.05579C18.1197 13.8452 13.9845 18.0638 8.88042 17.9999C4.01555 17.9361 -0.0398285 13.8332 4.74466e-05 8.91211C0.0399234 4.14271 4.04347 -0.0479753 9.11569 -8.17411e-05C14.0045 0.0478118 18.1635 4.16267 17.9961 9.05579ZM6.77497 10.5006C5.82991 9.4589 5.02043 8.56488 4.12721 7.57508C3.47324 8.25358 2.92694 8.86023 2.33678 9.415C1.96593 9.76222 1.93403 9.9977 2.32083 10.3729C3.67262 11.6859 5.00448 13.019 6.3164 14.372C6.69522 14.7631 6.93049 14.6993 7.27741 14.344C8.40191 13.1866 9.55432 12.0611 10.6948 10.9197C12.3656 9.24737 14.0324 7.5671 15.7152 5.9028C16.0621 5.55956 16.078 5.31211 15.7112 4.98085C15.2446 4.56178 14.794 4.11877 14.3793 3.64781C14.0244 3.24072 13.7891 3.30058 13.4343 3.66777C11.2849 5.89881 9.11569 8.1059 6.77896 10.4966L6.77497 10.5006Z"
        fill="#231F20"
      />
    </svg>
  );
}
